import { Routes } from '@angular/router';
import {AuthGuard} from '../../appauth/auth/auth.guard';
import { ObservacioneListaComponent } from './view-observacione/observacionevista.component';
export const ObservacionesRoutes: Routes = [{
	path: '',
	redirectTo: 'observacione-lista',
	pathMatch: 'full',
	canActivate: [AuthGuard]
},{
	path: '',
	children: [{
		path: 'observacione-lista',
		component: ObservacioneListaComponent,
		canActivate: [AuthGuard]
	}]
}];
